import React from 'react';
import { Section } from './ui/Section';
export function TimeFlexibility() {
  return <Section className="bg-[#0f0f0f]" data-id="element-250">
      <div className="max-w-4xl mx-auto" data-id="element-251">
        <h2 className="text-3xl md:text-4xl font-black text-white text-center mb-12" data-id="element-252">
          “¿Y si no tengo 7 minutos?”
        </h2>

        <div className="space-y-6" data-id="element-253">
          {/* 90s */}
          <div className="flex flex-col md:flex-row gap-6 items-center bg-[#111111] border border-gray-800 p-6 rounded-xl" data-id="element-254">
            <div className="bg-[#2563EB]/10 text-[#2563EB] font-black text-xl px-4 py-2 rounded-lg whitespace-nowrap" data-id="element-255">
              Reset 90s
            </div>
            <p className="text-gray-300 text-lg" data-id="element-256">
              Cuando estás en el baño, pasillo, o literal a punto de entrar.
            </p>
          </div>

          {/* 3 min */}
          <div className="flex flex-col md:flex-row gap-6 items-center bg-[#111111] border border-gray-800 p-6 rounded-xl" data-id="element-257">
            <div className="bg-[#2563EB]/10 text-[#2563EB] font-black text-xl px-4 py-2 rounded-lg whitespace-nowrap" data-id="element-258">
              Reset 3 min
            </div>
            <p className="text-gray-300 text-lg" data-id="element-259">
              Cuando tienes un break mini.
            </p>
          </div>

          {/* 7 min */}
          <div className="flex flex-col md:flex-row gap-6 items-center bg-[#111111] border border-[#2563EB]/30 p-6 rounded-xl shadow-[0_0_20px_rgba(37,99,235,0.1)]" data-id="element-260">
            <div className="bg-[#2563EB] text-white font-black text-xl px-4 py-2 rounded-lg whitespace-nowrap" data-id="element-261">
              Reset 7 min
            </div>
            <p className="text-white font-medium text-lg" data-id="element-262">
              Cuando quieres volver a control de verdad.
            </p>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-263">
          <p className="text-2xl font-bold text-gray-400" data-id="element-264">
            No es “hazlo perfecto”. <br data-id="element-265" />
            <span className="text-white" data-id="element-266">Es “hazlo posible”.</span>
          </p>
        </div>
      </div>
    </Section>;
}